// extracted by mini-css-extract-plugin
export default {"logo":"Board_logo__BFWXx","navbar":"Board_navbar__qZMDf","box":"Board_box__Y-dq9","title":"Board_title__wBt37","subtitle":"Board_subtitle__0VE-4"};